import React, { useRef, useState } from 'react';
import { Typography700 } from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/common/components/Logical/LayoutV2/FooterV2/FooterSubscribe/FooterSubscribe.styles';
import {
  Grid, Button, Box, TextField,
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import axios, { API } from 'lib/config/axios';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackbar } from 'redux/features/ui-slice';
import ReCAPTCHA from 'react-google-recaptcha';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import Typography500 from 'views/common/components/UI/Typography500';

const { envVars } = require('next/config').default().publicRuntimeConfig;

const FooterSubscribe = () => {
  const { t } = useTranslation('common_layout_v2');
  const { appState, googleAnalytics } = useSelector(
    (state) => state.globalData,
  );
  const recaptchaRef = useRef();
  const dispatch = useDispatch();
  const handleErrorResponse = useErrorsHandler();

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const sendNewletter = async (recaptchaToken) => {
    const { email, fullName } = formData;
    axios
      .post(API.newslettersSubscribe, {
        authenticity_token: appState.authenticity_token,
        'g-recaptcha-response': recaptchaToken,
        'iv-g-recaptcha': '1',
        newsletter_subscription: {
          email,
          full_name: fullName,
        },
      })
      .then((res) => {
        const { data } = res;
        window.gtag('event', 'newsletter_signup', {
          event_category: googleAnalytics.newsLetterEventCategory,
          event_label: 'Newsletter',
          event_action: 'Lead',
        });
        dispatch(
          setSnackbar({
            open: true,
            severity: 'success',
            message: data.message,
          }),
        );
      })
      .catch((error) => {
        let message = '';
        let isExpected = false; // Whether if error is expected or not
        if (error.response?.status && error.response.data) {
          switch (error.response.status) {
            case 406:
            case 403:
              if (error.response.data.message) {
                message = error.response.data.message;
              }
              isExpected = true;
              break;
            default:
              break;
          }
        }
        if (message) {
          dispatch(
            setSnackbar({
              open: true,
              severity: 'error',
              message,
            }),
          );
        }
        if (!isExpected) {
          handleErrorResponse(error);
        }
      })
      .finally(() => {
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
      });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    recaptchaRef.current.execute();
  };

  return (
    <StyledBox>
      <Typography700 component="p" variant="h3" className="FSTitle">
        {t('common_layout_v2:the_journey_continue')}
      </Typography700>
      <Typography500
        component="p"
        variant="body2"
        className="FSDesc"
        dangerouslySetInnerHTML={{
          __html: t('common_layout_v2:subscribe_text_desc'),
        }}
      />
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing="0">
          <Grid item lg={4} md={12} sm={12}>
            <TextField
              fullWidth
              required
              className="FSInput FSNameInput"
              label={t('common_layout_v2:full_name')}
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={6} md={12} sm={12}>
            <TextField
              className="FSInput FSEmailInput"
              fullWidth
              required
              id="email"
              label={t('common_layout_v2:email_address')}
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={2} md={12} sm={12}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              className="FSSubBtn">
              {t('common_layout_v2:subscribe')}
            </Button>
          </Grid>
        </Grid>
        <ReCAPTCHA
          className="FSCaptcha"
          ref={recaptchaRef}
          sitekey={envVars.INVISIBLE_RECAPTCHA_SITE_KEY}
          size="invisible"
          onChange={sendNewletter}
        />
      </Box>
    </StyledBox>
  );
};

export { FooterSubscribe };
